import React, { useState } from "react";

import cx from "classnames";
import { Button, Container, Row, Col } from "reactstrap";
import { Link, useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { setUserKeys } from "../../_redux/actions/auth";

import ApiContext from "../../weaveapi/apicontext";
import WeaveTopBar from "../../components/WeaveTopBar/WeaveTopBar";
import BackButton from "../../components/BackButton";
import FileUpload from "../../components/FileUpload/FileUpload";

import LoginImg from "../../assets/images/welcome/login.svg";

import s from "../../pages/welcome/Welcome.module.scss";

export default function LoginPage(props) {
	const history = useHistory();
	const dispatch = useDispatch();
	const [privateKey, setPrivateKey] = useState(null);
	const [fileName, setFileName] = useState("");

	const { demoData } = useSelector((state) => state.demo || {});

	// ------------------------------------- METHODS -------------------------------------
	const onUploadComplete = (k) => {
		if (k) {
			setPrivateKey(k);
		}
	};

	const onContinue = () => {
		// TODO: 2022.09.28 Login via Weave for Marketplace
		if (props.onComplete) {
			return props.onComplete();
		}

		const keys = ApiContext.deriveKeys(privateKey);

		dispatch(
			setUserKeys({
				pub: keys[0],
				pvk: keys[1],
			})
		).then(() => {
			history.push("/sidechains");
		});
	};

	const fillDemoData = () => {
		setFileName(demoData?.buyer?.privateKeyFilename);
		setPrivateKey(demoData?.weave?.privateKey);
	};

	return (
		<div className={s.welcome}>
			<WeaveTopBar onFill={fillDemoData} />

			<Container fluid className={s.welcomePage}>
				<BackButton />

				<Row className={s.titleContainer}>
					<Col lg="12" sm="12">
						<div className="d-flex align-items-center justify-content-center">
							<p className={s.title}>welcome back!</p>
						</div>
					</Col>
				</Row>

				<div className={s.content}>
					<Row className={s.mediaContainer} style={{ marginBottom: 43 }}>
						<Col lg="12" sm="12">
							<div className="d-flex align-items-center justify-content-center">
								<img src={LoginImg} alt="..." className={s.loginImg} />
							</div>
						</Col>
					</Row>

					{/* Public key */}
					<FileUpload
						accept=".pvk"
						fileName={fileName}
						verifyContent={ApiContext.verifyKey}
						onFileChange={onUploadComplete}
						infoText={
							<>
								Sign with your encrypted private key file here -{" "}
								<span>this key does not leave your local system</span>
							</>
						}
					/>

					<Row className={cx(s.btnContainer, "row")} style={{ marginTop: 56 }}>
						<Col sm="12" className="d-flex justify-content-center">
							<Button
								color="primary"
								className="btn-default"
								disabled={!privateKey}
								onClick={onContinue}
							>
								Continue
							</Button>
						</Col>
						<Col sm="12" className="d-flex justify-content-center">
							<Link to="/welcome/establish">
								<Button color="link" className={s.registerButton}>
									No account yet? Create New account here
								</Button>
							</Link>
						</Col>
					</Row>
				</div>
			</Container>
		</div>
	);
}
